module.exports = __webpack_public_path__ + "img/check.25172bc8.svg";